/* BUILD YOUR CICLE — COPY
   Everything the tool says, in English and Dutch.
   Safe to edit: no logic in this file. Keys must stay as they are.
   Written to sit inside the voice of the live product pages: plain, second person,
   cause and effect, no promises of transformation.

   T.benefit / T.moment / T.claims are TRANSLATIONS ONLY. Which badges a product
   carries is decided on the product itself, in Shopify: custom.benefit_badges,
   custom.moment_badges and custom.badges_secondary. The keys below are the badge
   text in lowercase; a badge with no key here falls back to its English text.
   EXTRAS      what we say about a product that did not make it into the routine. */
window.RF_COPY = (function () {
  var T = {
    "en": {
      "freeFromH": "Clean by design",
      "claims": {
        "fragrance free": "Fragrance free",
        "paraben free": "Paraben free",
        "silicone free": "Silicone free",
        "sulfate free": "Sulfate free",
        "microplastic free": "Microplastic free",
        "essential oil free": "Essential oil free",
        "vegan": "Vegan",
        "natural": "% natural"
      },
      "progQ": function (i, n) { return "question " + i + " of " + n; },
      "skinWord": function (x) { return x.toLowerCase() + " skin"; },
      "progR": "your cicle",
      "q1": {
        "h": "What does your day usually look like?",
        "s": "Routines are built around what your skin actually experiences.",
        "max": "Two is the maximum. Deselect one to swap it."
      },
      "q2": {
        "h": "What's your skin type?",
        "s": "Mostly it decides which cleanser you get."
      },
      "q3": {
        "h": "Anything you'd like to work on?",
        "s": "Your skin is probably fine. This only sets the priority."
      },
      "q4": {
        "h": "Is your skin sensitive?",
        "s": "Every ingredient has a job. This decides what we leave out."
      },
      "o1": [
        ["out", "Outdoors", "Commuting, city days, time outside"],
        ["indoor", "At a desk", "Screens, office air, heating"],
        ["sweat", "Training", "Gym, running, after workouts"],
        ["long", "Travelling", "Flights, hotels, changing climates"]
      ],
      "o2": [
        ["normal", "Normal", "Balanced. Not tight, not shiny"],
        ["dry", "Dry", "Feels tight, can flake"],
        ["oily", "Oily", "Shiny by midday, visible pores"],
        ["combi", "Combination", "Oily T-zone, drier cheeks"]
      ],
      "o3": [
        ["breakouts", "Breakouts", "Spots, blackheads, congestion"],
        ["dry", "Dryness and sensitivity", "Tightness, flaking, redness"],
        ["dull", "Dullness and uneven tone", "Dull skin, dark marks, uneven tone"],
        ["lines", "Fine lines and firmness", "Fine lines, loss of firmness"],
        ["none", "Nothing specific", "I just want a routine that works"]
      ],
      "o4": [
        ["low", "Not really", "New products rarely bother it"],
        ["some", "Sometimes", "Some products sting or turn it red"],
        ["high", "Yes", "It reacts easily, so I introduce things slowly"]
      ],
      "change": "change",
      "back": "Back",
      "next": "Continue",
      "see": "See my cicle",
      "slot": {
        "cleanse": "cleanse",
        "boost": "boost",
        "protect": "protect",
        "boostOn": "boost · retinol nights",
        "boostOff": "boost · other nights"
      },
      "morning": "morning",
      "evening": "evening",
      "amSub": "in this order, before you leave",
      "pmSub": "in this order, before bed",
      "emptyEve": "Nothing extra. A clean face at night is enough.",
      "twiceADay": "One bottle, morning and evening.",
      "priceH": "What it costs",
      "total": "Total",
      "cta": "Add this cicle",
      "cartError": "Something went wrong adding these to your cart. Please try again.",
      "restart": "Start again",
      "closing": "A routine you keep, not a problem you chase.",
      "disclaim": "This recommends cosmetics, it doesn't diagnose skin. If your skin is painful, breaking out suddenly, or you're being treated for a condition, see a GP or dermatologist first, and take this list with you.",
      "buildPre": "For ",
      "withWord": " with ",
      "reactPhrase": ", sensitive",
      "typeNames": {
        "normal": "normal",
        "dry": "dry",
        "oily": "oily",
        "combi": "combination"
      },
      "concernShort": {
        "breakouts": "breakouts",
        "dry": "dryness and sensitivity",
        "dull": "dullness and uneven tone",
        "lines": "fine lines and firmness",
        "none": ""
      },
      "dayPhrase": {
        "out": "days outdoors",
        "indoor": "desk days",
        "sweat": "training days",
        "long": "travel"
      },
      "tiers": [
        ["essential", "Essential", "Two steps in the morning. Cleanse and protect"],
        ["complete", "Complete", "Morning and evening, with a serum where it counts"]
      ],
      "tierH": "How much do you want to use?",
      "tierS": "",
      "discountNote": function (pct, min) {
  return min + " products or more, " + pct + "% off. It comes off in the cart.";
},
      "discountRow": function (pct) { return pct + "% off"; },
      "subtotal": "Subtotal",
      "resultH": "Your cicle",
      "benefit": {
        "deep clean": "deep clean",
        "calm redness": "calm redness",
        "prevent congestion": "prevent congestion",
        "non-stripping cleanse": "non-stripping cleanse",
        "calms": "calms",
        "nourishes": "nourishes",
        "deep hydration": "deep hydration",
        "barrier support": "barrier support",
        "absorbs instantly": "absorbs instantly",
        "antioxidant support": "antioxidant support",
        "brightens": "brightens",
        "stays potent": "stays potent",
        "renews": "renews",
        "smooths": "smooths",
        "evens tone": "evens tone",
        "firms": "firms",
        "plumps": "plumps",
        "broad-spectrum spf": "broad-spectrum SPF",
        "lightweight hydration": "lightweight hydration"
      },
      "moment": {
        "after workouts": "after workouts",
        "after city days": "after city days",
        "to remove sunscreen": "to remove sunscreen",
        "when skin feels tight": "when skin feels tight",
        "nighttime": "at night",
        "every morning": "every morning",
        "long screen days": "on long screen days",
        "sunny days": "on sunny days",
        "city living": "in the city",
        "during travel": "when you travel",
        "in dry office air": "in dry office air",
        "stressed skin": "when skin is stressed",
        "after a breakout": "after a breakout",
        "before outdoors": "before you go outside",
        "on commute days": "on commute days"
      },
      "extrasH": "For other days",
      "extrasS": "Use one or use them all.",
      "addLabel": "Add",
      "inCicle": "In your cicle",
      "emptyCart": "Nothing selected.",
      "keepH": "Keep your cicle",
      "keepS": "The link holds your answers, so you can come back to it or send it to someone.",
      "copyLabel": "Copy link",
      "copied": "Copied",
      "emailLabel": "Email it to me",
      "emailField": "Email",
      "emailSend": "Send",
      "emailNote": "Just this one email, unless you tick the box.",
      "emailOptIn": "Send me the occasional Cicle email too",
      "emailDone": "On its way.",
      "emailBad": "That does not look like an email address.",
      "pmSubAlt": "two or three nights with retinol, hydration on the nights between",
      "offNight": "On the nights you skip retinol, this is the middle step.",
      "offNightTwice": "The same bottle as the morning. On the nights you skip retinol, this is the middle step.",
      "pickHint": "Uncheck anything you already have. The price follows.",
      "discountAll": function (pct) { return pct + "% off. It comes off in the cart."; }
    },
    "nl": {
      "freeFromH": "Bewust clean",
      "claims": {
        "fragrance free": "Parfumvrij",
        "paraben free": "Parabenenvrij",
        "silicone free": "Siliconenvrij",
        "sulfate free": "Sulfaatvrij",
        "microplastic free": "Microplasticsvrij",
        "essential oil free": "Zonder etherische oliën",
        "vegan": "Vegan",
        "natural": "% natuurlijk"
      },
      "progQ": function (i, n) { return "vraag " + i + " van " + n; },
      "skinWord": function (x) { var m = { normaal: "een normale huid", droog: "een droge huid", vet: "een vette huid", gecombineerd: "een gecombineerde huid" }; return m[x] || x; },
      "progR": "jouw cicle",
      "q1": {
        "h": "Hoe ziet je dag er meestal uit?",
        "s": "We stemmen de routine af op wat je huid daadwerkelijk meemaakt.",
        "max": "Twee is het maximum. Zet er één uit om te wisselen."
      },
      "q2": {
        "h": "Wat is je huidtype?",
        "s": "Het bepaalt vooral welke reiniger je krijgt."
      },
      "q3": {
        "h": "Iets wat je wil aanpakken?",
        "s": "Er is waarschijnlijk niks mis met je huid. Dit bepaalt alleen de prioriteit."
      },
      "q4": {
        "h": "Is je huid gevoelig?",
        "s": "Elk ingrediënt heeft een taak. Dit bepaalt wat we weglaten."
      },
      "o1": [
        ["out", "Buiten", "Onderweg, dagen in de stad, tijd buiten"],
        ["indoor", "Achter een bureau", "Schermen, droge kantoorlucht, verwarming"],
        ["sweat", "Sporten", "Sportschool, hardlopen, na workouts"],
        ["long", "Reizen", "Vluchten, hotels, wisselende klimaten"]
      ],
      "o2": [
        ["normal", "Normaal", "In balans. Niet strak, niet glanzend"],
        ["dry", "Droog", "Voelt strak, kan schilferen"],
        ["oily", "Vet", "Glanzend halverwege de dag, zichtbare poriën"],
        ["combi", "Gecombineerd", "Vette T-zone, drogere wangen"]
      ],
      "o3": [
        ["breakouts", "Onzuiverheden", "Puistjes, mee-eters, verstopte poriën"],
        ["dry", "Droogte en gevoeligheid", "Trekkerig, schilferig, rood"],
        ["dull", "Matheid en ongelijke huidtint", "Doffe huid, vlekjes, ongelijke tint"],
        ["lines", "Fijne lijntjes en stevigheid", "Fijne lijntjes, minder stevigheid"],
        ["none", "Niets specifieks", "Ik wil gewoon een routine die werkt"]
      ],
      "o4": [
        ["low", "Niet echt", "Nieuwe producten geven zelden problemen"],
        ["some", "Soms", "Sommige producten prikken of maken rood"],
        ["high", "Ja", "Mijn huid reageert snel, ik bouw langzaam op"]
      ],
      "change": "wijzig",
      "back": "Terug",
      "next": "Verder",
      "see": "Bekijk mijn cicle",
      "slot": {
        "cleanse": "reinigen",
        "boost": "boost",
        "protect": "beschermen",
        "boostOn": "boost · retinol-avonden",
        "boostOff": "boost · andere avonden"
      },
      "morning": "ochtend",
      "evening": "avond",
      "amSub": "in deze volgorde, voordat je weggaat",
      "pmSub": "in deze volgorde, voor het slapen",
      "emptyEve": "Niets extra. 's Avonds een schoon gezicht is genoeg.",
      "twiceADay": "Eén flacon, ochtend en avond.",
      "priceH": "Wat het kost",
      "total": "Totaal",
      "cta": "Voeg deze cicle toe",
      "cartError": "Er ging iets mis bij het toevoegen aan je winkelwagen. Probeer het opnieuw.",
      "restart": "Opnieuw beginnen",
      "closing": "Een routine die je volhoudt, geen probleem dat je najaagt.",
      "disclaim": "Dit adviseert cosmetica, het stelt geen diagnose. Als je huid pijnlijk is, plotseling opkomt, of je wordt behandeld voor een aandoening, ga dan eerst naar je huisarts of dermatoloog en neem deze lijst mee.",
      "buildPre": "Voor ",
      "withWord": " met ",
      "reactPhrase": ", gevoelig",
      "typeNames": {
        "normal": "normaal",
        "dry": "droog",
        "oily": "vet",
        "combi": "gecombineerd"
      },
      "concernShort": {
        "breakouts": "onzuiverheden",
        "dry": "droogte en gevoeligheid",
        "dull": "matheid en ongelijke huidtint",
        "lines": "fijne lijntjes en stevigheid",
        "none": ""
      },
      "dayPhrase": {
        "out": "dagen buiten",
        "indoor": "bureaudagen",
        "sweat": "sportdagen",
        "long": "reizen"
      },
      "tiers": [
        ["essential", "Essentieel", "Twee stappen in de ochtend. Reinigen en beschermen"],
        ["complete", "Compleet", "Ochtend en avond, met een serum waar het uitmaakt"]
      ],
      "tierH": "Hoeveel wil je gebruiken?",
      "tierS": "",
      "discountNote": function (pct, min) {
  return min + " producten of meer, " + pct + "% korting. Die gaat er in de winkelwagen vanaf.";
},
      "discountRow": function (pct) { return pct + "% korting"; },
      "subtotal": "Subtotaal",
      "resultH": "Jouw cicle",
      "benefit": {
        "deep clean": "diepe reiniging",
        "calm redness": "kalmeert roodheid",
        "prevent congestion": "voorkomt verstopte poriën",
        "non-stripping cleanse": "reinigt zonder uit te drogen",
        "calms": "kalmeert",
        "nourishes": "voedt",
        "deep hydration": "diepe hydratatie",
        "barrier support": "ondersteunt de barrière",
        "absorbs instantly": "trekt direct in",
        "antioxidant support": "antioxidantbescherming",
        "brightens": "verheldert",
        "stays potent": "blijft werkzaam",
        "renews": "vernieuwt",
        "smooths": "maakt gladder",
        "evens tone": "egaliseert de teint",
        "firms": "verstevigt",
        "plumps": "vult op",
        "broad-spectrum spf": "breedspectrum SPF",
        "lightweight hydration": "lichte hydratatie"
      },
      "moment": {
        "after workouts": "na het sporten",
        "after city days": "na dagen in de stad",
        "to remove sunscreen": "om zonnebrand af te halen",
        "when skin feels tight": "als je huid trekt",
        "nighttime": "'s avonds",
        "every morning": "elke ochtend",
        "long screen days": "op lange schermdagen",
        "sunny days": "op zonnige dagen",
        "city living": "in de stad",
        "during travel": "op reis",
        "in dry office air": "in droge kantoorlucht",
        "stressed skin": "bij gestreste huid",
        "after a breakout": "na onzuiverheden",
        "before outdoors": "voordat je naar buiten gaat",
        "on commute days": "op woon-werkdagen"
      },
      "extrasH": "Voor andere dagen",
      "extrasS": "Gebruik er één, of allemaal.",
      "addLabel": "Toevoegen",
      "inCicle": "In je cicle",
      "emptyCart": "Niets geselecteerd.",
      "keepH": "Bewaar je cicle",
      "keepS": "De link bewaart je antwoorden, dus je kunt er later op terugkomen of hem doorsturen.",
      "copyLabel": "Kopieer link",
      "copied": "Gekopieerd",
      "emailLabel": "Mail hem naar me",
      "emailField": "E-mail",
      "emailSend": "Versturen",
      "emailNote": "Alleen deze ene mail, tenzij je het vakje aanvinkt.",
      "emailOptIn": "Stuur me ook af en toe een mail van Cicle",
      "emailDone": "Onderweg.",
      "emailBad": "Dat lijkt geen e-mailadres.",
      "pmSubAlt": "twee of drie avonden met retinol, hydratatie op de avonden ertussen",
      "offNight": "Op de avonden zonder retinol is dit de middenstap.",
      "offNightTwice": "Dezelfde fles als 's ochtends. Op de avonden zonder retinol is dit de middenstap.",
      "pickHint": "Vink uit wat je al hebt. De prijs past zich aan.",
      "discountAll": function (pct) { return pct + "% korting. Die gaat er in de winkelwagen vanaf."; }
    }
  };

  var REASONS = {
    "en": {
      "rr": {
        "sweat": "Cools and calms skin on contact, and clears pores that sweat has clogged.",
        "out": "Removes what a day in the city leaves behind, and takes your SPF off with it.",
        "breakouts": "Dissolves oil and daily buildup, so congestion doesn't get the chance to form.",
        "oily": "Cleans properly without stripping, so you aren't shiny again by midday.",
        "combi": "Clears the T-zone without drying out your cheeks.",
        "def": "Cleans without drying out your skin and rinses clean, so the leave-on steps absorb properly."
      },
      "mm": {
        "sens": "Cleans without fragrance and without stripping, for skin that reacts to most things.",
        "dry": "Takes off makeup and buildup without taking your moisture with it.",
        "drytype": "Rinses clean and leaves your skin comfortable, not tight.",
        "dull": "Mild gluconolactone exfoliation, so texture smooths without the sting of an acid.",
        "def": "Cleans without drying out your skin, so the leave-on steps absorb properly."
      },
      "pp": {
        "dull": "Vitamin C that stays potent all day and absorbs without stinging, for brighter, more even skin.",
        "lines": "Antioxidant defence against the daily damage that ages skin, before it reaches you.",
        "out": "Defends against pollution and sun on city days, and sits under your SPF.",
        "indoor": "Helps your skin handle the daily toll of blue light, screens and dry office air.",
        "def": "Adds antioxidant defence and sits under your SPF."
      },
      "hh": {
        "dry": "One pump keeps your skin hydrated and comfortable all day, instead of tight by the afternoon.",
        "long": "Builds up your barrier before flights, hotels and changing climates, rather than repairing after.",
        "indoor": "Holds moisture through a day of air conditioning and dry office air.",
        "drytype": "Multi-layer hydration that keeps working, so your skin stops feeling tight.",
        "breakouts": "Hydration without oil, so you can clear congestion without drying your skin out.",
        "def": "Adds moisture and forms the layer Daily Defense goes over."
      },
      "cc": {
        "breakouts": "Retinol and niacinamide overnight, so oil and redness settle down by morning.",
        "dull": "Works with your skin's overnight repair, so texture and tone even out over the weeks.",
        "lines": "Retinol at night, for firmness and fine lines. The slow step, but the one that works.",
        "def": "One step for the night. Retinol and niacinamide, fragrance free."
      },
      "dw": {
        "long": "Rebuilds the barrier overnight, after the days that take it apart.",
        "dry": "Deep overnight hydration that holds, so you wake up comfortable instead of tight.",
        "drytype": "Peptides and niacinamide overnight, for skin that never quite stays comfortable.",
        "lines": "Firmness overnight, without the weight of a traditional night cream.",
        "def": "Closes off the evening steps and works with your skin's overnight repair."
      },
      "dd": {
        "breakouts": "SPF 30 in a light moisturiser, made for skin that breaks out from heavier sunscreens.",
        "lines": "The step that does most for how your skin ages. Broad-spectrum, every morning.",
        "dull": "Broad-spectrum SPF 30, because protecting an even tone is easier than correcting one.",
        "indoor": "Every morning, even at a desk. UVA gets through glass.",
        "out": "Broad-spectrum SPF 30 that absorbs clean. No white cast, no heavy feel.",
        "def": "Light enough to forget you're wearing SPF, protective enough to trust."
      }
    },
    "nl": {
      "rr": {
        "sweat": "Koelt en kalmeert je huid bij contact, en maakt poriën vrij die dichtzitten van zweet.",
        "out": "Verwijdert wat een dag in de stad achterlaat, en haalt je SPF er in één keer af.",
        "breakouts": "Lost olie en dagelijkse ophoping op, zodat poriën niet verstopt raken.",
        "oily": "Reinigt goed zonder te strippen, zodat je huid niet halverwege de dag alweer glimt.",
        "combi": "Maakt de T-zone schoon zonder je wangen uit te drogen.",
        "def": "Reinigt zonder uit te drogen en spoelt schoon af, zodat de leave-on producten goed intrekken."
      },
      "mm": {
        "sens": "Reinigt zonder parfum en zonder te strippen, voor een huid die snel op dingen reageert.",
        "dry": "Haalt make-up en dagelijkse ophoping weg zonder je vocht mee te nemen.",
        "drytype": "Spoelt schoon af en laat je huid comfortabel achter, niet trekkerig.",
        "dull": "Milde exfoliatie met gluconolacton, dus je huid wordt gladder zonder het prikken van een zuur.",
        "def": "Reinigt zonder uit te drogen, zodat de leave-on producten goed intrekken."
      },
      "pp": {
        "dull": "Vitamine C die de hele dag werkzaam blijft en intrekt zonder te prikken, voor een stralende, egale huid.",
        "lines": "Antioxidant-bescherming tegen de dagelijkse schade die je huid sneller doet verouderen.",
        "out": "Beschermt tegen vervuiling en zon op dagen in de stad, en gaat onder je SPF.",
        "indoor": "Helpt je huid omgaan met blauw licht, schermtijd en droge kantoorlucht.",
        "def": "Vormt de antioxidantlaag onder je SPF."
      },
      "hh": {
        "dry": "Eén pompje houdt je huid de hele dag gehydrateerd en comfortabel, in plaats van trekkerig tegen de middag.",
        "long": "Versterkt je huidbarrière vóór vluchten, hotels en klimaatwisselingen, in plaats van herstellen achteraf.",
        "indoor": "Houdt vocht vast door een dag airco en droge kantoorlucht.",
        "drytype": "Hydratatie in meerdere lagen die blijft werken, zodat je huid niet meer strak aanvoelt.",
        "breakouts": "Hydratatie zonder olie, dus je kunt onzuiverheden aanpakken zonder je huid uit te drogen.",
        "def": "Voegt vocht toe en vormt de laag waar Daily Defense overheen gaat."
      },
      "cc": {
        "breakouts": "Retinol en niacinamide 's nachts, zodat talg en roodheid tegen de ochtend tot rust komen.",
        "dull": "Werkt mee met het herstel 's nachts, zodat textuur en huidtint over de weken egaler worden.",
        "lines": "Retinol 's nachts, voor stevigheid en fijne lijntjes. De langzame stap, maar wel degene die werkt.",
        "def": "Eén stap voor de nacht. Retinol en niacinamide, parfumvrij."
      },
      "dw": {
        "long": "Bouwt je huidbarrière 's nachts weer op, na de dagen die hem afbreken.",
        "dry": "Diepe hydratatie voor de nacht die blijft zitten, zodat je comfortabel wakker wordt in plaats van trekkerig.",
        "drytype": "Peptiden en niacinamide 's nachts, voor een huid die nooit helemaal comfortabel blijft.",
        "lines": "Stevigheid 's nachts, zonder het zware gevoel van een klassieke nachtcrème.",
        "def": "Sluit de avondstappen af en werkt mee met het herstel 's nachts."
      },
      "dd": {
        "breakouts": "SPF 30 in een lichte moisturizer, gemaakt voor een huid die uitbreekt van zwaardere zonnebrand.",
        "lines": "De stap die het meest doet voor hoe je huid veroudert. Breedspectrum, elke ochtend.",
        "dull": "Breedspectrum SPF 30, want een egale huid beschermen is makkelijker dan hem corrigeren.",
        "indoor": "Elke ochtend, ook achter een bureau. UVA komt door glas.",
        "out": "Breedspectrum SPF 30 die mooi intrekt. Zonder witte waas of zwaar gevoel.",
        "def": "Licht genoeg om te vergeten dat je SPF draagt, beschermend genoeg om op te vertrouwen."
      }
    }
  };

  var REASON_ORDER = {
    "rr": ["sweat", "breakouts", "oily", "combi", "out"],
    "mm": ["sens", "dry", "drytype", "dull"],
    "pp": ["dull", "lines", "out", "indoor"],
    "hh": ["dry", "long", "indoor", "drytype", "breakouts"],
    "cc": ["breakouts", "dull", "lines"],
    "dw": ["long", "dry", "drytype", "lines"],
    "dd": ["breakouts", "lines", "dull", "indoor", "out"]
  };

  var PMETA = {
    "rr": {
      "inci": "Aloe Vera · Green Tea · Salicylic Acid",
      "note": {
        "en": "Contains fragrance.",
        "nl": "Bevat parfum."
      }
    },
    "mm": {
      "inci": "Glycerin · Gluconolactone · Glycolic Acid"
    },
    "pp": {
      "inci": "Vitamin C · Ferulic Acid · Gold",
      "note": {
        "en": "Contains fragrance, and vitamin C can tingle at first.",
        "nl": "Bevat parfum, en vitamine C kan in het begin tingelen."
      }
    },
    "hh": {
      "inci": "Hydro Boost · Hyaluronic Acid · Phytoceramide"
    },
    "cc": {
      "inci": "Niacinamide · Retinol · Vitamin E",
      "note": {
        "en": "Two or three nights a week to start. Build up from there if your skin stays comfortable.",
        "nl": "Twee of drie avonden per week om te beginnen. Bouw daarna op als je huid comfortabel blijft."
      }
    },
    "dw": {
      "inci": "Niacinamide · Peptides · Hyaluronic Acid"
    },
    "dd": {
      "inci": "SPF 30 · Vitamin E · Hyaluronic Acid",
      "note": {
        "en": "Contains alcohol as a formulation aid.",
        "nl": "Bevat alcohol als formuleringshulpstof."
      }
    }
  };

  var EXTRAS = {
    "rr": {
      "moment": "after workouts",
      "en": "For the days you train. Clears sweat and buildup without stripping.",
      "nl": "Voor de dagen dat je sport. Haalt zweet en ophoping weg zonder te strippen."
    },
    "mm": {
      "moment": "nighttime",
      "en": "The gentler cleanse, for the evenings your skin has had enough.",
      "nl": "De zachtere reiniging, voor de avonden dat je huid genoeg heeft gehad."
    },
    "pp": {
      "moment": "sunny days",
      "en": "For days outside and long screen days. Sits under your SPF.",
      "nl": "Voor dagen buiten en veel schermtijd. Gaat onder je SPF."
    },
    "hh": {
      "moment": "during travel",
      "en": "For flights, hotels and dry office air, when your skin dries out faster than usual.",
      "nl": "Voor vluchten, hotels en droge kantoorlucht, als je huid sneller uitdroogt dan normaal."
    },
    "cc": {
      "moment": "nighttime",
      "en": "When you are ready for retinol. Two nights a week is enough to start.",
      "nl": "Als je toe bent aan retinol. Twee avonden per week is genoeg om te beginnen."
    },
    "dw": {
      "moment": "nighttime",
      "en": "For colder nights, or after the days that take your barrier apart.",
      "nl": "Voor koudere nachten, of na de dagen die je huidbarrière afbreken."
    },
    "dd": {
      "moment": "every morning",
      "en": "Every morning, even at a desk. UVA gets through glass.",
      "nl": "Elke ochtend, ook achter een bureau. UVA komt door glas."
    }
  };

  return { T: T, REASONS: REASONS, REASON_ORDER: REASON_ORDER, PMETA: PMETA, EXTRAS: EXTRAS };
})();
